import { artists as actions } from "actions";
import { statuses } from "api";

const initialState = {
   get: {
      status: statuses.idle,
   },
   search: {
      status: statuses.idle,
   },
   insert: {
      status: statuses.idle,
   },
   update: {
      status: statuses.idle,
   },
   delete: {
      status: statuses.idle,
   },
};

function artistsSaga(state = initialState, { type, payload }: any) {
   switch (type) {
      case actions.search.send:
         return {
            ...state,
            search: {
               status: statuses.pending,
               ...payload,
            },
         };
      case actions.search.success:
         return {
            ...state,
            search: {
               status: statuses.resolved,
               ...payload,
            },
         };
      case actions.search.fail:
         return {
            ...state,
            search: {
               status: statuses.rejected,
               reset: actions.search.reset,
               ...payload,
            },
         };
      case actions.search.reset:
         return {
            ...state,
            search: {
               status: statuses.idle,
               ...payload,
            },
         };
      default:
         return state;
   }
}

export default artistsSaga;

export { actions };
export { artistsSaga };
